class ConfiguratorFurniture {
    constructor() {
        this.id = 'furniture';
        this.cache = {};
        this.sizes = [];

        this.selectors = [];
        if (bed_configuration.selectors.includes('fabric')) { this.selectors.push('fabric'); }
        if (bed_configuration.selectors.includes('size')) { this.selectors.push('size'); }
        if (bed_configuration.selectors.includes('firmness')) { this.selectors.push('firmness'); }

        for (const sel of this.selectors) {
            configurator.addSelectorItem(sel);
        }

        this.init();
    }

    async init() {
    }

    isValidSelector(selector) {
        return this.selectors.includes(selector);
    }
    
    setupListeners() {
    }

    async refresh(selector) {
        console.log(`[FURNITURE] refresh() called, trigger: ${selector}`);
        console.log(`[FURNITURE] selectors: ${JSON.stringify(this.selectors)}`);
        console.log(`[FURNITURE] configurator.selection BEFORE:`, JSON.stringify(configurator.selection));
        console.log(`[FURNITURE] cache keys BEFORE: ${JSON.stringify(Object.keys(this.cache))}`);

        if (this.selectors.includes('fabric') && !configurator.selection['fabric']) {
            configurator.selection['fabric'] = '0LLG'; // Default?
        }

        if (this.selectors.includes('fabric') && this.selectors.includes('size')) {
            // Load only products for current fabric
            console.log(`[FURNITURE] Branch: fabric+size, checking cache for fabric: ${configurator.selection.fabric}`);
            if (!(configurator.selection.fabric in this.cache)) {
                await this.loadBuyables( configurator.selection.fabric );
            }
        } else {
            // Load all products
            console.log(`[FURNITURE] Branch: no-fabric or no-size, cache length: ${Object.keys(this.cache).length}`);
            if (Object.keys(this.cache).length == 0) {
                await this.loadBuyables();
            }
        }

        console.log(`[FURNITURE] cache keys AFTER load: ${JSON.stringify(Object.keys(this.cache))}`);
        for (const key in this.cache) {
            console.log(`[FURNITURE] cache['${key}'] sizes: ${JSON.stringify(Object.keys(this.cache[key].sizes))}`);
        }
        console.log(`[FURNITURE] configurator.selection AFTER load:`, JSON.stringify(configurator.selection));
        
        if (this.selectors.includes('fabric')) { this.populateFabrics(); }
        if (this.selectors.includes('size')) { this.populateSizes(); }
        if (this.selectors.includes('firmness')) { this.populateFirmnesses(); }
    }

    populateFabrics() {
        const items = [];
        let g = "";

        for (const key in configurator.m3_fabrics) {
            if (configurator.m3_fabrics[key][3] != 1) { continue; }

            const thumbnail = configurator.getSwatch(configurator.m3_fabrics[key][0]);
            const item = {
                'id': key,
                'label': configurator.m3_fabrics[key][1],
                'thumbnail': thumbnail,
                'group_by': configurator.m3_fabrics[key][2],
                'available': true,
            };
            
            items.push(item);
        }

        configurator.renderSelector('fabric', items, {
            'thumbnails': true,
            'allow_none': false,
        });
    }

    populateSizes() {
        const fabric = this.selectors.includes('fabric') ? (configurator.selection.fabric ?? '0LLG') : 'default';
        console.log(`[FURNITURE] populateSizes() — lookup key: '${fabric}', cache has key: ${fabric in this.cache}, cache keys: ${JSON.stringify(Object.keys(this.cache))}`);
        if (!this.cache[fabric]) {
            console.error(`[FURNITURE] populateSizes() FAILED — cache['${fabric}'] is undefined!`);
            return;
        }
        const sizes = this.cache[ fabric ]['sizes'];
        const items = [];

        // Sort sizes
        var sizesSorted = [].slice.call(Object.keys(sizes)).sort((a, b) => {
            const a1 = a.split('x');
            const b1 = b.split('x');
            
            // Special case for Pinno with side table - make sure it comes after the regular option
            if (a.toLowerCase().includes('st') && !b.toLowerCase().includes('st')) {
                return 1; // Put ST option after
            } else if (!a.toLowerCase().includes('st') && b.toLowerCase().includes('st')) {
                return -1; // Keep non-ST option before
            }
            
            return a1[0] - b1[0] || a1[1] - b1[1];
        });

        for (const size of sizesSorted) {
            const item = {
                'id': size,
                'label': size.replace('x', ' x '),
                'thumbnail': null,
                'available': true,
            };
            
            // Special handling for Pinno with side table
            if (bed_configuration.category && bed_configuration.category.toLowerCase().includes('pinno')) {
                if (size.toLowerCase().includes('st')) {
                    item.label = item.label + ' ST'; // Add ST to the label
                    console.log(`Added ST to the label for ${size}: ${item.label}`);
                }
            }
            
            items.push(item);
        }

        console.log("Final size items to render:", items.length);
        
        configurator.renderSelector('size', items, {
            'columns': 5, 
            'allow_none': false
        });
        if (configurator.selection.size != null) { configurator.updateSelectorState( 'size' ); }
    }

    populateFirmnesses() {
        const fabric = this.selectors.includes('fabric') ? (configurator.selection.fabric ?? '0LLG') : 'default';
        console.log(`[FURNITURE] populateFirmnesses() — lookup key: '${fabric}', cache has key: ${fabric in this.cache}`);
        if (!this.cache[fabric]) {
            console.error(`[FURNITURE] populateFirmnesses() FAILED — cache['${fabric}'] is undefined!`);
            return;
        }
        const sizes = this.cache[ fabric ]['sizes'];
        const firmnesses = sizes[ configurator.selection.size ].firmnesses;

        configurator.renderSelector('firmness', Object.values(firmnesses), {
            'columns': 5,
            'allow_none': false,
        });
    }

    async loadBuyables(fabric) {
        const filters = [
            {key: 'category', value: bed_configuration.category},
        ];
        if (fabric) {
            filters.push({key: 'fabric', value: fabric});
        }

        console.log(`[FURNITURE] Using collection: configurator-${bed_configuration.collection}`);
        console.log(`[FURNITURE] Using filters: ${JSON.stringify(filters)}`);
        
        const products = await configurator.loadProductData('configurator-'+bed_configuration.collection, filters, ['size', 'fabric', 'width', 'height', 'length'], true);
        console.log(`[FURNITURE] loadBuyables() returned ${products.length} products`);
        for (const p of products) {
            console.log(`[FURNITURE]   product: ${p.handle}, size=${p.size}, fabric=${p.fabric}, productid=${p.productid}, category=${p.category}, variants=${p.variants.length}`);
            for (const v of p.variants) {
                console.log(`[FURNITURE]     variant: ${v.title}, price=${v.price}, sku=${v.sku}, available=${v.availableForSale}`);
            }
        }

        if (products.length === 0) {
            console.warn(`[FURNITURE] 0 products found! Fetching collection WITHOUT category filter to diagnose...`);
            const allProducts = await configurator.loadProductData('configurator-'+bed_configuration.collection, [], ['size', 'fabric', 'width', 'height', 'length'], false);
            console.warn(`[FURNITURE] Collection 'configurator-${bed_configuration.collection}' contains ${allProducts.length} total products:`);
            for (const p of allProducts) {
                console.warn(`[FURNITURE]   handle=${p.handle}, productid=${p.productid}, category=${p.category}, size=${p.size}`);
            }
            console.warn(`[FURNITURE] Expected category filter value: '${bed_configuration.category}'`);
        }

        const urlParams = new URLSearchParams(window.location.search);
        const variant_id = 'gid://shopify/ProductVariant/' + urlParams.get('variant');
        
        for (const product of products) {
            const size = product.size ? product.size : 'nosize';
            const fabric = this.selectors.includes('fabric') ? product.fabric : 'default';

            if (!(fabric in this.cache)) {
                this.cache[ fabric ] = { 'title': fabric, 'sizes': {} };
            }
            
            if (this.selectors.includes('firmness')) {
                this.cache[ fabric ].sizes[ size ] = {
                    'title': size, 'firmnesses': {},
                };

                for (const variant of product.variants) {
                    // Skip variants with price 0 when e-commerce is enabled
                    if (variant.price == 0 && configurator.enable_ecommerce == true) { continue; }
                    
                    const firm_key = variant.title.toLowerCase().replace(/\s/g, '').replace(/,/g, '-');
                    const item = configurator.variantToItem(product, variant);

                    item.id = firm_key;
                    item.label = variant.title;
                    item.dimensions = [product.width/10, product.length/10, product.height/10];

                    this.cache[ fabric ].sizes[ size ].firmnesses[ firm_key ] = item;
                    
                    if (variant.id.replace('gid://shopify/ProductVariant/', '') == variant_id) {
                        // Set fabric, size, variant selections
                        for (const s of this.selectors) {
                            configurator.selection[s] = variant[s];
                        }
                    }
                }
            } else {
                const variant = product.variants[0];
                if (!variant) { continue; }
                
                // Skip variants with price 0 when e-commerce is enabled
                if (variant.price == 0 && configurator.enable_ecommerce == true) { continue; }

                const item = configurator.variantToItem(product, variant);
                
                // For Pinno products, mark if this is the ST variant
                if (product.productid && product.productid.toLowerCase().includes('pinno') && 
                    (product.productid.toLowerCase().includes('st') || size.toLowerCase().includes('st'))) {
                    item.isSideTable = true;
                    
                    // If the size doesn't already include 'st', add it to make it distinct
                    if (!size.toLowerCase().includes('st')) {
                        const newSize = size + 'st';
                        this.cache[fabric].sizes[newSize] = item;
                    } else {
                        this.cache[fabric].sizes[size] = item;
                    }
                } else {
                    console.log(`Adding size ${size} for fabric ${fabric}: ${item.label}, id: ${item.id}`);
                    this.cache[fabric].sizes[size] = item;
                }
                
                // Set dimensions
                if (this.cache[fabric].sizes[size]) {
                    this.cache[fabric].sizes[size].dimensions = [product.width/10, product.length/10, product.height/10];
                }
            }
        }

        this.setDefaults();
    }

    setDefaults() {
        const fabric = this.selectors.includes('fabric') ? (configurator.selection.fabric ?? '0LLG') : 'default';
        console.log(`[FURNITURE] setDefaults() — fabric key: '${fabric}', cache has key: ${fabric in this.cache}`);
        if (!this.cache[fabric]) {
            console.error(`[FURNITURE] setDefaults() — cache['${fabric}'] is undefined! Cache keys: ${JSON.stringify(Object.keys(this.cache))}`);
            return;
        }
        if (this.selectors.includes('size') && configurator.selection['size'] == null) {
            const sizes = this.cache[fabric]['sizes'];
            console.log(`[FURNITURE] setDefaults() — setting default size from: ${JSON.stringify(Object.keys(sizes))}`);
            configurator.selection['size'] = Object.keys(sizes)[0];
        }
        // Default firmness
        if (this.selectors.includes('firmness') && configurator.selection['firmness'] == null) {
            configurator.selection['firmness'] = 'medium';
        }
    }

    isSoldOut() {
        const fabric = this.selectors.includes('fabric') ? (configurator.selection.fabric ?? '0LLG') : 'default';
        
        // Check if cache or fabric exists
        if (!this.cache || !this.cache[fabric]) {
            console.warn(`[WARNING] Cache not found for fabric: ${fabric}`);
            return true; // Consider it sold out if data isn't available
        }
        
        // Check if sizes exists for this fabric
        if (!this.cache[fabric]['sizes']) {
            console.warn(`[WARNING] No sizes found in cache for fabric: ${fabric}`);
            return true;
        }
        
        const sizes = this.cache[fabric]['sizes'];
        const selectedSize = configurator.selection.size ?? 'nosize';
        
        // Check if the selected size exists
        if (!sizes[selectedSize]) {
            console.warn(`[WARNING] Selected size not found: ${selectedSize}`);
            return true;
        }
        
        let item = sizes[selectedSize];

        if (item && 'firmnesses' in item) {
            const selectedFirmness = configurator.selection.firmness;
            if (!selectedFirmness || !item.firmnesses[selectedFirmness]) {
                console.warn(`[WARNING] Selected firmness not found: ${selectedFirmness}`);
                return true;
            }
            item = item.firmnesses[selectedFirmness] ?? null;
        }

        if (item != null && item.available == true) { return false; }
        return true;
    }

    getPriceData(priceData) {
        const items = [];
        const fabric = this.selectors.includes('fabric') ? (configurator.selection.fabric ?? '0LLG') : 'default';
        
        // Add safety checks to handle missing data
        if (!this.cache[fabric]) {
            console.warn(`[WARNING] No data found in cache for fabric: ${fabric}`);
            return;
        }
        
        const sizes = this.cache[fabric]['sizes'];
        if (!sizes) {
            console.warn(`[WARNING] No sizes found in cache for fabric: ${fabric}`);
            return;
        }
        console.log(`### Available sizes for fabric ${fabric}:`, Object.keys(sizes));
        
        // Determine if we should use a specific size or the default 'nosize'
        // If we don't have a size selector, always use 'nosize'
        const selectedSize = this.selectors.includes('size') 
            ? (configurator.selection.size ?? Object.keys(sizes)[0]) 
            : 'nosize';
        console.log(`### Selected size: ${selectedSize}`);
        
        if (!sizes[selectedSize]) {
            console.warn(`[WARNING] Selected size not found in cache: ${selectedSize}`);
            // Try to use the first available size as fallback
            const availableSizes = Object.keys(sizes);
            if (availableSizes.length > 0) {
                configurator.selection.size = availableSizes[0];
                console.log(`### Falling back to size: ${availableSizes[0]}`);
            } else {
                return;
            }
        }

        let item = sizes[configurator.selection.size || selectedSize];
        console.log(`### Item for selected size:`, item);

        // Load base with specific fabric
        if (this.selectors.includes('firmness') && 'firmness' in configurator.selection) {
            console.log(`### Checking firmness: ${configurator.selection.firmness}`);
            if (!item.firmnesses || !item.firmnesses[configurator.selection.firmness]) {
                console.warn(`[WARNING] Selected firmness not found: ${configurator.selection.firmness}`);
                console.log("### Available firmnesses:", item.firmnesses ? Object.keys(item.firmnesses) : "none");
                // Try to use the first available firmness as fallback
                if (item.firmnesses && Object.keys(item.firmnesses).length > 0) {
                    const firstFirmness = Object.keys(item.firmnesses)[0];
                    configurator.selection.firmness = firstFirmness;
                    console.log(`### Falling back to firmness: ${firstFirmness}`);
                } else {
                    return;
                }
            }
            
            item = item.firmnesses[configurator.selection.firmness];
            console.log(`### Got firmness item:`, item);
        }

        if (item != null && item.skus != null) {
            const price = item.price ?? 0;
            console.log(`furniture => ${item.id} => ${price}`);
            console.log(`### Adding to price data - SKUs: ${item.skus}, IDs: ${item.ids}, Price: ${price}`);
            priceData.total += price;
            priceData.skus.push(...item.skus);
            priceData.ids.push(...item.ids);

            // Show dimensions for this item
            const dimensionsElement = document.querySelector('.dimensions');
            if (dimensionsElement && item.dimensions && item.dimensions.some(d => d > 0)) {
                dimensionsElement.querySelector('.dimensions-value').textContent = "B x L x H: " + item.dimensions.join(' x ') + " cm";
                dimensionsElement.hidden = false;
                console.log(`### Set dimensions: ${item.dimensions.join(' x ')} cm`);
            } else if (dimensionsElement) {
                dimensionsElement.hidden = true;
            }
        } else {
            console.warn("[WARNING] Item or SKUs are null:", item);
            console.log("### item details:", JSON.stringify(item));
        }
    }

    getCylindoSpecs(specs) {
        if (configurator.selection.fabric != null) {
            specs.features.UPHOLSTERY = configurator.m3_fabrics[ configurator.selection.fabric ][0];
        }
        
        // Check if this is the holmefabric product and set the "bedside table" feature to "UPHOLSTERED"
        const isHolmeFabric = bed_configuration.category === "holmefabric" || 
                             (bed_configuration.cylindo_model && 
                              bed_configuration.cylindo_model.toLowerCase().includes('holme'));
        
        if (isHolmeFabric) {
            // For Holme fabric nightstand, set the bedside table feature to UPHOLSTERED
            specs.features['bedside table'] = 'UPHOLSTERED';
        }
        
        const size_conversion = {
            'borno': { 'default': '120x90', '>105': '120x140', '>140': '120x180' },
            'lilla borno': { 'default': '120x90', '>105': '120x140', '>140': '120x180' },
            // 'low torno': { 'default': null },
            // 'torno': { 'default': null },
            'ango': { 'default': '120x90', '>105': '120x140', '>140': '120x180' },
            'lilla borno': { '==90': '200x90', '==105': '200x105', '==120': '200x120' }, // lillabornol, lillabornor
            'rivo': { 'default': '120X90', '>105': '120x140', '>140': '120x180' },
            'solo 120': { 'default': '120X90', '>105': '120x140', '>140': '120x180' },
            'solo 107': { 'default': '120X90', '>105': '120x140', '>140': '120x180' },
            'rixo': { 'default': '80x55 x 2', '==180': '90X55 x 2', '==210': '105x55 x 2' },

            'lilla harpo': { 'default': '200x90', '>105': '200x140', '>140': '200x180' },
            'stora harpo': { 'default': '200x90', '>105': '200x140', '>140': '200x180' },

            'luxury topper': { 'default': '200x90', '>105': '200x140', '>140': '200x180' },
            'luxury mattress split': { 'default': '' },

            'pinno': { 'default': '186', '==158': '158', '==186': '186', '==218': '218', '==282': '282' },
            'full walnut headboard': { 'default': '186', '==156': '156', '==186': '186', '==216': '216', '==252': '252', '==282': '282', '==312': '312' }, // ottero
        };

        const model = bed_configuration.cylindo_model.toLowerCase();

        if (model in size_conversion) {
            const size_arr = configurator.selection.size.split('x');
            let width = parseInt(size_arr[0]);
            let model_size = '';

            for (const key in size_conversion[model]) {
                if (key == 'default' || eval(width + key)) {
                    model_size = size_conversion[model][key];
                }
            }
            
            if (model == 'lilla borno') {
                if (this.cache[ configurator.selection['fabric'] ]['sizes'][configurator.selection.size].label.includes('Right') ) {
                    model_size += ' right';
                } else {
                    model_size += ' left';
                }
            }

            if (model == 'pinno') {
                const p = this.cache['default'].sizes[configurator.selection.size];
                if (p.id == 'pinno282x149') { model_size += ' CM WITHOUT SIDE TABLE NO PANEL'; }
                if (p.id == 'pinno282x149st') { model_size += ' CM WITH SIDE TABLE NO PANEL'; }
            }
            
            specs.features.size = model_size.toUpperCase();
        }
    }
}
